import TranslationData from '@/models/TranslationData';

const translation: TranslationData = {
  search: {
    title: 'Recherche',
  },
  searchResults: {
    showMore: 'Afficher plus de résultats',
    noResults: 'Nous n’avons trouvé aucun résultat pour votre recherche <b>{storeSearchTerm}</b>',
    noResultsHint: '',
    badges: {
      pfsc: '',
      fsc: '',
      fsc_pfsc: 'FSC® ou PEFC',
      ecofriendly: 'Matériaux écoresponsables',
      overnight: 'Livraison en 24h et express',
      sameday: 'Sameday',
      express: 'Express',
      onlineDesign: 'Concevoir en ligne',
    },
    taglines: {
      home: 'En savoir plus',
      text: 'En savoir plus',
      themes: 'En savoir plus',
      external: 'En savoir plus',
      info: 'En savoir plus',
      category: 'En savoir plus',
      content: 'En savoir plus',
      product: 'Configurez ici',
    },
    headings: {
      categories: 'Catégories de produits',
      products: 'Produits',
      external: 'Autre site',
    },
    slider: {
      previousSlide: 'Afficher le contenu précédent',
      nextSlide: 'Afficher le contenu suivant',
    },
  },
  searchInput: {
    inputTooShortError: 'Votre terme de recherche est trop court (min 2)',
    results: 'Résultats',
    result: 'Résultat',
    youSearchFor: 'Résultats pour',
    suggestedTerm: {
      didYouMean: 'Voulez-vous dire',
      resultsFor: 'Essayez avec l\'orthographe',
      didYouMeanPostFix: '?',
      resultsForPostFix: '',
    },
  },
  toolsBar: {
    buttons: {
      listButtonTooltip: 'Vue liste',
      gridButtonTooltip: 'Affichage en mosaïque',
    },
    quickFilter: {
      filterChips: {
        clearAllFilters: 'Effacer tous les filtres',
        resetFilters: '',
      },
      buttonsPanel: {
        filterLabel: 'Filtres',
        buttonsTooltipLabel: 'Vue',
        resultLabel: 'Résultats de recherche',
      },
      contexts:
        {
          product: 'Produits',
          content: 'Divers',
          all: 'all',
          category: 'Catégories de produits',
          external: 'Autre site',
        },
    },
    breadcrumbs: {
      start: 'Départ',
      search: 'Recherche',
    },
  },
  sideBar: {
    filter: 'Filtre',
    filterOverwrite: {
      category: {
        text: 'Catégories',
      },
      rootCategory: {
        text: 'Catégories',
      },
      specialFeatures: {
        text: 'Special Features',
        options: {
          logoFsc: 'Logo FSC',
          logoPfsc: 'Logo PFSC',
          logoFscPfsc: '',
          samedayAvailable: 'Livraison le jour même',
          expressAvailable: 'Livraison express',
          overnightAvailable: 'Livraison le lendemain',
          ecoFriendly: 'Matériaux respectueux de l\'environnement',
          onlineDesign: 'Conception en ligne',
          new: 'New',
        },
      },
    },
    more: 'Show more',
    less: 'Show less',
  },
  common: {
    warnings: {
      server401: 'Votre session a expiré et vous devez vous reconnecter. Vous serez immédiatement redirigé vers l\'ouverture de session',
      server403: 'La demande n\'a pas été appliquée car elle ne contient pas d\'informations d\'authentification valides. Veuillez recharger la page ou contacter notre service clientèle.',
      default: 'Une erreur s\'est produite sur le serveur. Veuillez recharger la page ou contacter notre service clientèle.',
    },
    errors: {
      server400: 'La requête est malformée. Veuillez recharger la page ou contacter notre service clientèle.',
      server404: '404 Page not found. Veuillez aller à la page précédente ou contacter notre service clientèle',
      server500: 'Une erreur s\'est produite sur le serveur. Veuillez recharger la page ou contacter notre service clientèle.',
      server501: 'Une erreur s\'est produite sur le serveur. Please reload the page or contact our customer service.", server501 : "There was an error on the server. Please reload the page or contact our customer service.',
      server502: 'Une erreur s\'est produite sur le serveur et vous obtenez une réponse invalide. Veuillez recharger la page ou contacter notre service clientèle',
      server503: 'Une erreur s\'est produite sur le serveur. Veuillez recharger la page ou contacter notre service clientèle',
      server504: 'Une erreur s\'est produite sur le serveur. Veuillez recharger la page ou contacter notre service clientèle.',
      default: 'Le serveur a un problème avec la requête. Veuillez recharger la page ou contacter notre service clientèle.',
    },
  },
};
export default translation;
